import { createAction, props } from '@ngrx/store';
import { FetchArgs, PagingTokenFixed } from 'src/app/shared/models/core';
import { VendorAdminGridItem } from '../../vendor-admin/models/vendor-admin-grid-item';

export const setVendorFetchArgs = createAction(
    '[VENDOR ADMIN COMPONENT] Set vendor fetch args',
    props<{ fetchArgs: FetchArgs }>()
);

export const getListOfVendorAdminRecordsSuccess = createAction(
    '[VENDOR ADMIN API] Get List Of Vendor Admin Records Success',
    props<{ vendorAdminRecords: PagingTokenFixed<VendorAdminGridItem[]> }>()
);

export const getListOfVendorAdminRecordsFailure = createAction(
    '[VENDOR ADMIN API] Get List Of Vendor Admin Records Failure',
    props<{ error: unknown }>()
);
